import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import BeatVoicesPage from "./pages/BeatVoicesPage";
import CulinaryAI from "./pages/CulinaryAI";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/beat-voices" element={<BeatVoicesPage />} />
      <Route path="/culinary-ai" element={<CulinaryAI />} />
    </Routes>
  );
}

export default App;
